<template>
    <v-data-table dense hide-default-footer item-key="homb_encrid"
        :headers="getHeaders()" 
        :items="data"
        :disable-pagination=true>

        <template v-slot:item="rebooking">
        
            <tr style="padding: 10px;">

                <td>{{ $moment(rebooking.item.created).format("DD-MM-YYYY") }}</td>
                <td>{{ rebooking.item.summary | max_char(50) }}</td>
                <td>{{ rebooking.item.status_display }}</td>
                <td>{{ rebooking.item.gebr_naam }}</td>
                <td>
                    <span v-if="!!rebooking.item.attachments" 
                          v-on:click="executeFunction(`attachments_${itemtype}`, rebooking.item.homb_encrid, rebooking.item.key)"
                          :class="{'row-pointer': !!rebooking.item.attachments}">
                        <v-badge color="grey lighten-2" overlap bordered offset-y="27" offset-x="23">
                            <template v-slot:badge>
                                <span>{{ rebooking.item.attachments }}</span> 
                            </template>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-avatar v-bind="attrs" v-on="on"                                               
                                              size="40" style="margin-top:4px;" class="button-margin-r">
                                        <v-icon small>mdi-paperclip</v-icon>
                                    </v-avatar>
                                </template>
                                <span>{{ itemtype }} {{ rebooking.item.key }} has {{ rebooking.item.attachments }} attachments</span>
                            </v-tooltip>
                        </v-badge>
                    </span>
                    <span v-else>
                        <v-btn x-small text icon disabled><v-icon small></v-icon></v-btn>
                    </span>
                </td>
                <td>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="executeFunction(`update_${itemtype}`, rebooking.item.homb_encrid, rebooking.item.key)"
                                class="button-margin-lr gridbutton">
                                <v-icon small>mdi-text-box-edit-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit/update {{ itemtype }} {{ rebooking.item.key }} </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="executeFunction(`add_upd_${itemtype}_event`, rebooking.item.homb_encrid, '')"
                                class="button-margin-lr gridbutton">
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Add new event for {{ itemtype }} {{ rebooking.item.key }} </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="executeFunction(`delete_${itemtype}`, rebooking.item.homb_encrid, rebooking.item.key)"
                                class="button-margin-l gridbutton">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Delete {{ itemtype }} {{ rebooking.item.key }} and all it's events and attachments </span>
                    </v-tooltip>
                    <br>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="executeFunction(`open_${itemtype}`, rebooking.item.homb_encrid, rebooking.item.key)"
                                class="button-margin-lr gridbutton mt-1 mb-1">
                                <v-icon small>mdi-folder-open-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Open overview events for {{ itemtype }} {{ rebooking.item.key }} </span>
                    </v-tooltip>
<!-- 
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="executeFunction(`email_${itemtype}`,rebooking.item.homb_encrid, rebooking.item.key)"
                                class="button-margin-lr gridbutton mt-1 mb-1">
                                <v-icon small>mdi-email-fast-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Send {{ itemtype }} {{ rebooking.item.key }} to ...</span>
                    </v-tooltip>    
-->
                </td>
            </tr>
        </template>
    </v-data-table>

</template>

<script>
    import mxmaxchar from '@/mixins/filtermaxchar';

    export default {
        mounted(){
        },
        props: {
            data: Array,
            itemtype: String,
        },
        components: {},
        mixins: [mxmaxchar],
        data() {
            return {
            }
        },
        methods: {                       
            getHeaders(){
                return [
                    { text: "Created", value: "created", sortable: false, width: "12%"},
                    { text: "Latest development", value: "summary", sortable: false},
                    { text: "Status", value: "status_display", sortable: false},
                    { text: "Assigned to", value: "gebr_naam", sortable: false},
                    { sortable: false, align: "start"},
                    { sortable: false, align: "start", width: "16%"},
                ];
            },  
            executeFunction(func, encrid, key){
                this.$emit('executeFunction',  [{field: 'function', value: func},  {field: 'encrid', value: encrid},  {field: 'key', value: key}]);
            },          
        }
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr{
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l{
        margin-left: 4px;
    }  
    .button-margin-r{
        margin-right: 6px;
    }  
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }
</style>